'use strict';

var icon = require('../../../../../../../../../../_virtual/icon2.cjs');
var intentionColors = require('../../base/ds5/intentionColors.cjs');

var hasRequiredIcon;

function requireIcon () {
	if (hasRequiredIcon) return icon.__exports;
	hasRequiredIcon = 1;

	var intentionColors$1 = intentionColors.__require();

	var ICON_INTENTIONS = /*#__PURE__*/ function(ICON_INTENTIONS) {
	    ICON_INTENTIONS[ICON_INTENTIONS["neutral"] = intentionColors$1.INTENTION_COLORS.neutral] = "neutral";
	    ICON_INTENTIONS[ICON_INTENTIONS["inverse"] = intentionColors$1.INTENTION_COLORS.inverse] = "inverse";
	    ICON_INTENTIONS[ICON_INTENTIONS["alternate"] = intentionColors$1.INTENTION_COLORS.alternate] = "alternate";
	    ICON_INTENTIONS[ICON_INTENTIONS["discovery"] = intentionColors$1.INTENTION_COLORS.discovery] = "discovery";
	    ICON_INTENTIONS[ICON_INTENTIONS["recur"] = intentionColors$1.INTENTION_COLORS.recur] = "recur";
	    ICON_INTENTIONS[ICON_INTENTIONS["info"] = intentionColors$1.INTENTION_COLORS.info] = "info";
	    ICON_INTENTIONS[ICON_INTENTIONS["success"] = intentionColors$1.INTENTION_COLORS.success] = "success";
	    ICON_INTENTIONS[ICON_INTENTIONS["warning"] = intentionColors$1.INTENTION_COLORS.warning] = "warning";
	    ICON_INTENTIONS[ICON_INTENTIONS["critical"] = intentionColors$1.INTENTION_COLORS.critical] = "critical";
	    return ICON_INTENTIONS;
	}({});

	icon.__exports.ICON_INTENTIONS = ICON_INTENTIONS;
	
	return icon.__exports;
}

exports.__require = requireIcon;
//# sourceMappingURL=icon.cjs.map
